// CrewDashboard.js
import React, { useEffect, useState, useRef } from 'react';
import { Box, Typography, Card, CircularProgress, Divider, Avatar, Chip, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { connect } from 'react-redux'
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SpeedIcon from '@material-ui/icons/Speed';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import BuildIcon from '@material-ui/icons/Build';
import NatureIcon from '@material-ui/icons/Nature';

const CYCLE_INTERVAL_MS = 20000;

const useStyles = makeStyles((theme) => ({
  container: {
    background: '#0a0a0a',
    width: '100vw',
    height: '100vh',
    maxWidth: '100%',
    maxHeight: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    color: '#fff',
    boxSizing: 'border-box',
  },
  containerOld: {
    background: '#0a0a0a',
    padding: theme.spacing(1),
    fontFamily: 'Roboto, sans-serif',
    // width: '1920px',
    // width: '100vw',
    // height: '100vh',
    // height: '1080px',
    maxWidth: '100vw',
    height: '100vh',
    // aspectRatio: '16 / 9',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    // margin: '0 auto'
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1),
    overflow: 'hidden',
    height: '100%'
  },
  leftPanel: {
    position: 'relative',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 60%',
    marginRight: theme.spacing(1),
  },
  rightSidebar: {
    height: '100%',
    flex: '0 0 38%',
    display: 'flex',
    flexDirection: 'column',
  },
  summarySection: {
    background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    border: '1px solid #334155',
    flexShrink: 0,
  },
  statsGrid: {
    display: 'flex',
    flexDirection: 'column',
  },
  statItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    background: 'rgba(255,255,255,0.05)',
    '& .label': {
      fontSize: '0.875rem',
      color: '#94a3b8',
      textAlign: 'center',
    },
    '& .value': {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: '#4ade80',
    },
  },
  mainMap: {
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    border: '2px solid #334155',
    position: 'relative',
    background: '#0f172a',
    flex: 1,
    minHeight: 0,
    '& .leaflet-container': {
      width: '100%',
      height: '100%',
      background: '#0f172a',
    },
    '& .leaflet-tile-pane': {
      filter: 'brightness(0.7) contrast(1.1)',
    },
  },
  crewDetailBox: {
    background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    border: '1px solid #334155',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: 1,
  },
  crewDetailHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  miniMap: {
    width: '100%',
    height: 140,
    borderRadius: theme.spacing(0.5),
    border: '1px solid #334155',
    overflow: 'hidden',
  },
  crewInfoGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: theme.spacing(1),
  },
  workorderDetail: {
    background: 'rgba(255,255,255,0.05)',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  siteInfo: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
  },
  photoSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    background: 'rgba(255,255,255,0.03)',
    borderRadius: theme.spacing(1),
  },
  pastDueSection: {
    marginTop: 'auto',
  },
  pastDueTable: {
    fontSize: '0.875rem',
    '& th': {
      padding: theme.spacing(0.5),
      borderBottom: '1px solid #334155',
      color: '#94a3b8',
      fontWeight: 'normal',
      textAlign: 'left',
    },
    '& td': {
      padding: theme.spacing(0.5),
      borderBottom: '1px solid rgba(51, 65, 85, 0.3)',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '150px',
    },
  },
  pastDueHeader: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
    color: '#ef4444',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  pastDueItem: {
    background: 'rgba(239, 68, 68, 0.1)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  crewHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  crewAvatar: {
    width: 40,
    height: 40,
    border: '2px solid #4ade80',
  },
  vehicleMini: {
    fontSize: '0.9rem',
    opacity: 0.9,
    marginTop: theme.spacing(1),
  },
  mapLegend: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    background: 'rgba(15, 23, 42, 0.95)',
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(0.5),
    border: '1px solid #334155',
    zIndex: 1000,
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    fontSize: '0.875rem',
  },
  legendDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
  },
  photoTicker: {
    marginTop: theme.spacing(2),
    position: 'relative',
    width: '100%',
    minHeight: 165,
    overflow: 'hidden',
    borderRadius: theme.spacing(1),
    background: 'rgba(0,0,0,0.3)',
    border: '1px solid rgba(255,255,255,0.1)',
    flex: '0 1 auto',
  },
  photoTickerInner: {
    display: 'flex',
    gap: theme.spacing(1),
    animation: 'ticker 30s linear infinite',
    '&:hover': {
      animationPlayState: 'paused',
    },
  },
  photoTickerItem: {
    flexShrink: 0,
    position: 'relative',
    width: 480,
    height: '100%',
    minHeight: 150,
    maxHeight: 370,
    borderRadius: theme.spacing(0.5),
    overflow: 'hidden',
    background: '#000',
  },
  '@keyframes ticker': {
    '0%': {
      transform: 'translateX(0)',
    },
    '100%': {
      transform: 'translateX(-50%)',
    },
  },
}));

const CrewDashboard = (props) => {
  const classes = useStyles();
  const [crews, setCrews] = useState([]);
  const [stats, setStats] = useState(null);
  const [index, setIndex] = useState(0);
  const [workorderIndex, setWorkorderIndex] = useState(0);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [allWorkorders, setAllWorkorders] = useState([]);
  const [pastDueWorkorders, setPastDueWorkorders] = useState([]);
  const [hmiYardCoords, setHmiYardCoords] = useState([33.196885, -117.379467]); // Default
  const [secondsUntilNext, setSecondsUntilNext] = useState(20); // Countdown timer
  const [workorderDetails, setWorkorderDetails] = useState(null); // Store fetched workorder details
  const [photoTickerSpeed, setPhotoTickerSpeed] = useState(30); // Speed for ticker animation
  const [photoTickerComplete, setPhotoTickerComplete] = useState(false); // Track when last photo reaches middle
  const photoTickerRef = useRef(null);
  const mapRef = useRef(null);
  const mapContainerRef = useRef(null);
  const mainMapRef = useRef(null);
  const mainMapContainerRef = useRef(null);
  const miniMapRef = useRef(null);
  const miniMapContainerRef = useRef(null);
  const propertyMapRef = useRef(null); // For property boundary map
  const propertyMapContainerRef = useRef(null);
  const markersRef = useRef([]);
  const mainMarkersRef = useRef([]);
  
  // Refs for interval management
  const cycleIntervalRef = useRef(null);
  const dataIntervalRef = useRef(null);
  const crewsRef = useRef([]);
  const countdownIntervalRef = useRef(null);
  
  const API_URL = `${props.url}/api/hmi/crewdashboarddata?forTV=true`

  // Filter out crews with no jobs, vehicle, or location
  const filterActiveCrews = (crewList) => {
    return crewList.filter(crew => {
      const hasJobs = crew.todaySchedule && crew.todaySchedule.length > 0;
      const hasVehicle = crew.vehicle && (crew.vehicle.latitude || crew.vehicle.longitude);
      const hasLocation = (crew.mobileLocation && (crew.mobileLocation.latitude || crew.mobileLocation.longitude)) ||
                         (crew.bestLocation && (crew.bestLocation.latitude || crew.bestLocation.longitude));
      
      return hasJobs || hasVehicle || hasLocation;
    });
  };

  const activeCrews = filterActiveCrews(crews);
  const crew = activeCrews[index];

  window.onerror = function (msg) {
    const errorBox = document.createElement('div');
    errorBox.style.color = 'red';
    errorBox.style.background = 'black';
    errorBox.style.padding = '10px';
    errorBox.innerText = 'Error: ' + msg;
    document.body.appendChild(errorBox);
  };
  
  // Add debug info and viewport setup on mount
  useEffect(() => {
    // Debug info for TV
    console.log('[TV Dashboard] Browser:', navigator.userAgent);
    console.log('[TV Dashboard] Screen:', window.screen.width, 'x', window.screen.height);
    console.log('[TV Dashboard] Window:', window.innerWidth, 'x', window.innerHeight);
    
    // Check if running in Yodeck or similar player
    const isYodeck = navigator.userAgent.includes('Yodeck') || 
                     window.location.search.includes('yodeck') ||
                     window.innerWidth === window.screen.width;
    
    if (isYodeck) {
      console.log('[TV Dashboard] Yodeck player detected, applying specific styles');
      // For Yodeck, we need to check if we're in an iframe
      if (window.parent !== window) {
        // We're in an iframe, use parent dimensions
        document.documentElement.style.width = '100%';
        document.documentElement.style.height = '100%';
      }
      
      // Add Yodeck-specific CSS reset
      const yodeckStyle = document.createElement('style');
      yodeckStyle.innerHTML = `
        /* Yodeck specific resets */
        body > div:first-child {
          width: 100% !important;
          height: 100% !important;
          max-width: 100% !important;
          max-height: 100% !important;
        }
        .MuiBox-root {
          max-width: 100% !important;
        }
      `;
      document.head.appendChild(yodeckStyle);
    }
    
    // Ensure viewport meta tag
    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.name = 'viewport';
      document.head.appendChild(viewport);
    }
    viewport.content = 'width=1920, height=1080, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    
    // Force body styles for TV
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'hidden';
    document.body.style.boxSizing = 'border-box';
    
    // Add global box-sizing
    const globalStyle = document.createElement('style');
    globalStyle.innerHTML = `
      * {
        box-sizing: border-box;
      }
      html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
      #root {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    `;
    document.head.appendChild(globalStyle);
    
    // Add critical Leaflet CSS if not present
    if (!document.querySelector('style[data-leaflet-css]')) {
      const style = document.createElement('style');
      style.setAttribute('data-leaflet-css', 'true');
      style.innerHTML = `
        .leaflet-container {
          position: relative;
          overflow: hidden;
          -ms-touch-action: none;
          touch-action: none;
        }
        .leaflet-tile-pane { z-index: 2; }
        .leaflet-overlay-pane { z-index: 4; }
        .leaflet-shadow-pane { z-index: 5; }
        .leaflet-marker-pane { z-index: 6; }
        .leaflet-tooltip-pane { z-index: 7; }
        .leaflet-popup-pane { z-index: 8; }
        .leaflet-control { position: relative; z-index: 800; }
        .leaflet-top, .leaflet-bottom { position: absolute; z-index: 1000; }
        .leaflet-top { top: 0; }
        .leaflet-right { right: 0; }
        .leaflet-bottom { bottom: 0; }
        .leaflet-left { left: 0; }
      `;
      document.head.appendChild(style);
    }
  }, []);

  // Update crews ref when crews change
  useEffect(() => {
    const activeCrews = filterActiveCrews(crews);
    crewsRef.current = activeCrews;
    console.log('[TV Dashboard] Active crews:', activeCrews.length, 'out of', crews.length);
  }, [crews]);

  const refreshTheWorkorder = async (woIndex) => {
    console.log('Gotta get our photos and shit...', crew, woIndex)
    if (crew?.todaySchedule?.length && woIndex >= 0) {
      let activeWO = crew.todaySchedule[woIndex]
      console.log('new wo', activeWO)
      let ourQuery = `siteId=${activeWO?.jobSite?._id}&woId=${activeWO?.workorderId}`
      let URL = `${props.url}/api/hmi/fetchWoDetailsForTV?${ourQuery}`
      console.log('Refresh URL', URL)
      try {
        const res = await fetch(URL, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
        const json = await res.json();
        console.log('[TV Dashboard] Data fetched site details successfully');
        
        if (json.success && json.data) {
          console.log('got it..', json.data)
          setWorkorderDetails(json.data);
          setPhotoTickerComplete(false); // Reset completion flag
        }
      } catch (e) {
        console.log('error getting site details...', e)
      }
    }
  }

  useEffect(() => {
    console.log('Workorder index changed...', workorderIndex)
    refreshTheWorkorder(workorderIndex)
  }, [workorderIndex])

  // Calculate ticker speed based on number of photos
  useEffect(() => {
    if (workorderDetails?.uploads?.length > 0) {
      // Base speed of 8 seconds per photo (slower)
      const speed = Math.max(30, workorderDetails.uploads.length * 8);
      setPhotoTickerSpeed(speed);
      setPhotoTickerComplete(false);
      
      // Calculate when the last photo reaches middle
      // The animation goes to -50%, so we need to wait for about 75% completion
      // to have the last photo in the middle of the view
      const timeToMiddle = speed * 0.75 * 1000; // Convert to milliseconds
      
      if (photoTickerRef.current) {
        clearTimeout(photoTickerRef.current);
      }
      
      photoTickerRef.current = setTimeout(() => {
        console.log('[TV Dashboard] Last photo reached middle, ready to advance');
        setPhotoTickerComplete(true);
      }, timeToMiddle);
    } else {
      setPhotoTickerComplete(true); // No photos, can advance immediately
    }
    
    return () => {
      if (photoTickerRef.current) {
        clearTimeout(photoTickerRef.current);
      }
    };
  }, [workorderDetails])

  // Initialize jobsite map (with or without property boundaries)
  useEffect(() => {
    if (!propertyMapContainerRef.current) return;
    
    // Get current workorder and crew
    const activeCrewsList = filterActiveCrews(crews);
    const currentCrew = activeCrewsList[index];
    const currentWorkorder = currentCrew?.todaySchedule?.[workorderIndex];
    
    // Check if we have either property boundaries OR jobsite location
    const hasPropertyBounds = workorderDetails?.propertyLineData?.data?.[0]?.googleMapsFormat;
    const jobSiteCoords = currentWorkorder?.jobSite?.location?.coordinates || currentWorkorder?.location?.coordinates;
    
    if (!hasPropertyBounds && !jobSiteCoords) return;
    
    // Clear old map
    if (propertyMapRef.current) {
      try {
        propertyMapRef.current.off();
        propertyMapRef.current.remove();
      } catch (error) {
        console.warn('[TV Dashboard] Error removing property map:', error);
      }
      propertyMapRef.current = null;
    }
    
    let centerLat, centerLng, mapZoom = 15; // Zoomed out 2 levels from 17
    
    // Determine map center
    if (hasPropertyBounds) {
      const coords = workorderDetails.propertyLineData.data[0].googleMapsFormat;
      centerLat = coords.reduce((sum, coord) => sum + coord.lat, 0) / coords.length;
      centerLng = coords.reduce((sum, coord) => sum + coord.lng, 0) / coords.length;
    } else if (jobSiteCoords) {
      centerLat = jobSiteCoords[1];
      centerLng = jobSiteCoords[0];
      mapZoom = 16; // Zoomed out 2 levels from 18
    }
    
    // Create map
    propertyMapRef.current = L.map(propertyMapContainerRef.current, {
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      touchZoom: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      boxZoom: false,
      keyboard: false
    }).setView([centerLat, centerLng], mapZoom);
    
    // Add satellite imagery
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      attribution: '',
      maxZoom: 19
    }).addTo(propertyMapRef.current);
    
    // Add street labels overlay
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}{r}.png', {
      attribution: '',
      maxZoom: 19,
      opacity: 0.8
    }).addTo(propertyMapRef.current);
    
    // Add property boundary polygon if available
    if (hasPropertyBounds) {
      const coords = workorderDetails.propertyLineData.data[0].googleMapsFormat;
      const polygonCoords = coords.map(coord => [coord.lat, coord.lng]);
      L.polygon(polygonCoords, {
        color: '#4ade80',
        weight: 3,
        opacity: 0.8,
        fillColor: '#4ade80',
        fillOpacity: 0.1
      }).addTo(propertyMapRef.current);
      
      // Fit bounds to show entire property with padding
      const bounds = L.latLngBounds(polygonCoords);
      propertyMapRef.current.fitBounds(bounds, { padding: [30, 30] });
    } else if (jobSiteCoords) {
      // Add a marker for jobsite location
      const jobIcon = L.divIcon({
        html: `<div style="background-color: #4ade80; border: 3px solid #fff; border-radius: 50%; width: 16px; height: 16px; box-shadow: 0 2px 6px rgba(0,0,0,0.6);"></div>`,
        iconSize: [16, 16],
        iconAnchor: [8, 8],
        className: 'jobsite-marker'
      });
      
      L.marker([centerLat, centerLng], { icon: jobIcon }).addTo(propertyMapRef.current);
    }
    
    // Add crew vehicle marker if they're nearby
    if (currentCrew) {
      let crewLat, crewLng;
      
      // Get crew location (prefer vehicle, then mobile)
      if (currentCrew.vehicle?.latitude && currentCrew.vehicle?.longitude) {
        crewLat = currentCrew.vehicle.latitude;
        crewLng = currentCrew.vehicle.longitude;
      } else if (currentCrew.mobileLocation?.latitude && currentCrew.mobileLocation?.longitude) {
        crewLat = currentCrew.mobileLocation.latitude;
        crewLng = currentCrew.mobileLocation.longitude;
      } else if (currentCrew.bestLocation?.latitude && currentCrew.bestLocation?.longitude) {
        crewLat = currentCrew.bestLocation.latitude;
        crewLng = currentCrew.bestLocation.longitude;
      }
      
      // Add crew marker if we have their location
      if (crewLat && crewLng) {
        const crewIcon = L.divIcon({
          html: `<div style="position: relative;">
                   <div style="background-color: #3b82f6; padding: 4px; border-radius: 4px; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,0.6);">
                     <svg viewBox="0 0 24 24" style="width: 20px; height: 20px; fill: #fff;">
                       <path d="M18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5M19.5,9.5L21.46,12H17V9.5M6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5M20,8H17V4H3C1.89,4 1,4.89 1,6V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V12L20,8Z"/>
                     </svg>
                   </div>
                 </div>`,
          iconSize: [28, 28],
          iconAnchor: [14, 14],
          className: 'crew-truck-jobsite'
        });
        
        L.marker([crewLat, crewLng], { icon: crewIcon })
          .addTo(propertyMapRef.current)
          .bindPopup(`${currentCrew.name}<br/>Current location`);
      }
    }
    
  }, [workorderDetails, crews, index, workorderIndex])

  // Data fetching effect - runs once on mount and every 5 minutes
  useEffect(() => {
    console.log('[TV Dashboard] Setting up data fetching interval');
    fetchData();
    
    // Set up 5-minute refresh
    dataIntervalRef.current = setInterval(() => {
      console.log('[TV Dashboard] 5-minute data refresh triggered');
      fetchData();
    }, 300000); // 5 minutes
    
    return () => {
      console.log('[TV Dashboard] Cleaning up data interval');
      if (dataIntervalRef.current) {
        clearInterval(dataIntervalRef.current);
      }
    };
  }, []); // Empty dependency array - only run once on mount

  // Countdown timer effect - now considers photo ticker
  useEffect(() => {
    // Clear any existing countdown
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
    }
    
    // If we have photos and they're not complete, don't show countdown
    if (workorderDetails?.uploads?.length > 0 && !photoTickerComplete) {
      setSecondsUntilNext(-1); // -1 indicates waiting for photos
      return;
    }
    
    // Reset countdown when workorder changes
    setSecondsUntilNext(20);
    
    // Start countdown
    countdownIntervalRef.current = setInterval(() => {
      setSecondsUntilNext(prev => {
        if (prev <= 1) return 20;
        return prev - 1;
      });
    }, 1000);
    
    return () => {
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
      }
    };
  }, [index, workorderIndex, photoTickerComplete, workorderDetails]); // Reset countdown when position changes

  // Cycling effect - handles crew and workorder rotation
  useEffect(() => {
    console.log('[TV Dashboard] Setting up cycling interval, crews length:', crews.length);
    
    // Clear any existing interval
    if (cycleIntervalRef.current) {
      clearInterval(cycleIntervalRef.current);
    }
    
    // Only start cycling if we have crews
    if (crews.length > 0) {
      cycleIntervalRef.current = setInterval(() => {
        // Check if we should wait for photos to reach middle
        if (workorderDetails?.uploads?.length > 0 && !photoTickerComplete) {
          console.log('[TV Dashboard] Waiting for photos to reach middle');
          return; // Don't advance until photo ticker is complete
        }
        
        // Use functional updates to avoid stale closures
        setIndex(prevIndex => {
          const currentCrews = crewsRef.current;
          if (currentCrews.length === 0) return 0;
          
          const currentCrew = currentCrews[prevIndex];
          
          // Get current workorder index in a separate update
          setWorkorderIndex(prevWorkorderIndex => {
            if (!currentCrew || !currentCrew.todaySchedule || currentCrew.todaySchedule.length === 0) {
              // No workorders for this crew, move to next crew
              console.log('[TV Dashboard] No workorders for crew, moving to next');
              const nextCrewIndex = (prevIndex + 1) % currentCrews.length;
              // Update index in parent scope
              setTimeout(() => setIndex(nextCrewIndex), 0);
              return 0; // Reset workorder index
            }
            
            // Check if we need to move to next workorder or next crew
            if (prevWorkorderIndex + 1 >= currentCrew.todaySchedule.length) {
              // All workorders shown, move to next crew
              console.log('[TV Dashboard] All workorders shown, moving to next crew');
              const nextCrewIndex = (prevIndex + 1) % currentCrews.length;
              // Update index in parent scope
              setTimeout(() => setIndex(nextCrewIndex), 0);
              return 0; // Reset workorder index
            } else {
              // Show next workorder for current crew
              console.log('[TV Dashboard] Moving to next workorder:', prevWorkorderIndex + 1);
              return prevWorkorderIndex + 1;
            }
          });
          
          return prevIndex; // Keep same crew index for now
        });
      }, 20000); // 20 seconds per workorder
    }
    
    return () => {
      console.log('[TV Dashboard] Cleaning up cycling interval');
      if (cycleIntervalRef.current) {
        clearInterval(cycleIntervalRef.current);
      }
    };
  }, [crews.length, workorderDetails, photoTickerComplete]); // Depend on crews, workorder details, and photo completion

  // Manual navigation functions (optional enhancement)
  const navigateNext = () => {
    setIndex(prevIndex => {
      const currentCrews = crewsRef.current;
      if (currentCrews.length === 0) return 0;
      
      const currentCrew = currentCrews[prevIndex];
      
      setWorkorderIndex(prevWorkorderIndex => {
        if (!currentCrew || !currentCrew.todaySchedule || 
            currentCrew.todaySchedule.length === 0 || 
            prevWorkorderIndex + 1 >= currentCrew.todaySchedule.length) {
          // Move to next crew
          const nextCrewIndex = (prevIndex + 1) % currentCrews.length;
          setTimeout(() => setIndex(nextCrewIndex), 0);
          return 0;
        } else {
          // Next workorder
          return prevWorkorderIndex + 1;
        }
      });
      
      return prevIndex;
    });
  };
  
  const refreshCrew = () => {
    console.log('[TV Dashboard] Manual refresh triggered');
    fetchData();
  }

  const fetchData = async () => {
    console.log('[TV Dashboard] Fetching data...')
    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ location: { latitude: 33.123, longitude: -117.123 } }),
      });
      const json = await res.json();
      console.log('[TV Dashboard] Data fetched successfully');
      
      if (json.success) {
        const { crewsWithStatus, stats, rawData } = json.data;
        
        // Preserve current position if possible
        const currentCrewCount = crews.length;
        const newCrewCount = crewsWithStatus?.length || 0;
        
        setCrews(crewsWithStatus || []);
        setStats(stats || {});
        setAllWorkorders(rawData?.mtcWorkorders || []);
        
        // Get HMI Yard coordinates from response
        if (json.HMI_YARD_COORDINATES) {
          setHmiYardCoords([json.HMI_YARD_COORDINATES.lat, json.HMI_YARD_COORDINATES.lng]);
        }
        
        // Extract and sort past due workorders
        const pastDue = [];
        crewsWithStatus.forEach(crew => {
          if (crew.pastDueWorkorders && crew.pastDueWorkorders.length > 0) {
            pastDue.push(...crew.pastDueWorkorders);
          }
        });
        // Also check raw data for any past due workorders
        if (rawData?.pastDueWorkorders) {
          pastDue.push(...rawData.pastDueWorkorders);
        }
        // Sort by date (oldest first) and take top 10
        const sortedPastDue = pastDue
          .sort((a, b) => new Date(a.scheduledDate) - new Date(b.scheduledDate))
          .slice(0, 10);
        setPastDueWorkorders(sortedPastDue);
        
        setLastUpdated(new Date());
        
        // Only reset indices if crew structure changed significantly
        if (currentCrewCount === 0 || newCrewCount === 0) {
          console.log('[TV Dashboard] Resetting indices due to crew count change');
          setIndex(0);
          setWorkorderIndex(0);
        } else {
          // Validate current index is still valid
          setIndex(prevIndex => {
            if (prevIndex >= newCrewCount) {
              console.log('[TV Dashboard] Current index out of bounds, resetting');
              setWorkorderIndex(0);
              return 0;
            }
            return prevIndex;
          });
        }
      }
    } catch (err) {
      console.error('[TV Dashboard] Failed to fetch data:', err);
    }
  };

  const formatTime = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  const formatTimeAgo = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} ${diffMins === 1 ? 'minute' : 'minutes'} ago`;
    
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`;
    
    const diffDays = Math.floor(diffHours / 24);
    if (diffDays === 1) return `Yesterday at ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
    if (diffDays < 7) return `${diffDays} days ago`;
    
    // If more than a week, just show the date
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  // Function to fetch workorder details from API
  const fetchWorkorderDetails = async (workorderId) => {
    try {
      const response = await fetch(`/api/hmi/fetchWoDetailsForTV?workorderId=${workorderId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // Add auth headers if needed
          'Authorization': `Bearer ${localStorage.getItem('authToken') || ''}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('[TV Dashboard] Workorder details fetched:', data);
      return data;
    } catch (error) {
      console.error('[TV Dashboard] Error fetching workorder details:', error);
      return null;
    }
  };

  // Render main map with all crews
  useEffect(() => {
    console.log('[TV Dashboard] Map init check:', {
      hasContainer: !!mainMapContainerRef.current,
      crewsLength: crews.length,
      coords: hmiYardCoords
    });
    
    if (!mainMapContainerRef.current || crews.length === 0 || !hmiYardCoords[0] || !hmiYardCoords[1]) {
      console.log('[TV Dashboard] Skipping map render - missing requirements');
      return;
    }

    // Clear old map with error handling
    if (mainMapRef.current) {
      try {
        mainMapRef.current.off(); // Remove all event listeners
        mainMapRef.current.remove();
      } catch (error) {
        console.warn('[TV Dashboard] Error removing main map:', error);
      }
      mainMarkersRef.current = [];
      mainMapRef.current = null;
    }

    // Delay map creation to ensure DOM is ready
    setTimeout(() => {
      if (!mainMapContainerRef.current) return;
      
      // Get container dimensions
      const containerRect = mainMapContainerRef.current.getBoundingClientRect();
      console.log('[TV Dashboard] Map container dimensions:', containerRect.width, 'x', containerRect.height);
      
      // Create main map centered on HMI yard
      console.log('[TV Dashboard] Creating map with coords:', hmiYardCoords);
      try {
        mainMapRef.current = L.map(mainMapContainerRef.current, {
          zoomControl: false,  // Hide zoom controls for TV display
          preferCanvas: true,  // Better performance
          renderer: L.canvas()
        }).setView(
          hmiYardCoords,
          12 // Good zoom for satellite view
        );
        
        // Add tile error handling
        let tilesLoaded = false;
        const tileLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Tiles &copy; Esri',
          maxZoom: 19,
          crossOrigin: true,
          tileSize: 256,
          errorTileUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=='
        });
        
        tileLayer.on('tileerror', function(error) {
          console.error('[TV Dashboard] Tile loading error:', error);
          // If satellite tiles fail, try OSM fallback
          if (!tilesLoaded) {
            console.log('[TV Dashboard] Falling back to OSM tiles');
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
              attribution: '© OpenStreetMap contributors',
              maxZoom: 19
            }).addTo(mainMapRef.current);
          }
        });
        
        tileLayer.on('load', function() {
          tilesLoaded = true;
          console.log('[TV Dashboard] Tiles loaded successfully');
        });
        
        tileLayer.addTo(mainMapRef.current);
        
        // Force size recalculation
        setTimeout(() => {
          if (mainMapRef.current) {
            mainMapRef.current.invalidateSize();
            console.log('[TV Dashboard] Map size invalidated');
          }
        }, 100);
        
        console.log('[TV Dashboard] Map created successfully');
        
        // Create array to hold all marker positions for bounds calculation
        const allMarkerPositions = [];

    // Add all crew markers (only active crews)
    const activeCrewsList = filterActiveCrews(crews);
    const currentActiveCrewIndex = index; // Store current index for comparison
    
    activeCrewsList.forEach((crew, idx) => {
      let lat, lng;
      
      if (crew.vehicle?.latitude && crew.vehicle?.longitude) {
        lat = crew.vehicle.latitude;
        lng = crew.vehicle.longitude;
      } else if (crew.mobileLocation?.latitude && crew.mobileLocation?.longitude) {
        lat = crew.mobileLocation.latitude;
        lng = crew.mobileLocation.longitude;
      } else if (crew.bestLocation?.latitude && crew.bestLocation?.longitude) {
        lat = crew.bestLocation.latitude;
        lng = crew.bestLocation.longitude;
      }

      if (lat && lng) {
        // Check if this is the currently selected crew
        const isActiveCrew = idx === currentActiveCrewIndex;
        
        // Crew is working if they have a current workorder that's in progress or they're driving
        const isWorking = (crew.currentWorkorder?.status === 'in-progress') || 
                         (crew.vehicle?.isDriving) ||
                         (crew.currentWorkorder && !crew.currentWorkorder.workComplete);
        const color = isActiveCrew ? '#4ade80' : (isWorking ? '#3b82f6' : '#fbbf24');
        
        const crewIcon = L.divIcon({
          html: `<div style="position: relative;">
                   <div style="background-color: ${color}; border: 3px solid #fff; border-radius: 8px; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(0,0,0,0.6);">
                     <svg viewBox="0 0 24 24" style="width: 24px; height: 24px; fill: #fff;">
                       <path d="M18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5M19.5,9.5L21.46,12H17V9.5M6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5M20,8H17V4H3C1.89,4 1,4.89 1,6V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V12L20,8Z"/>
                     </svg>
                     <div style="position: absolute; top: -8px; right: -8px; background: #fff; color: ${color}; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 12px; border: 2px solid ${color};">${idx + 1}</div>
                   </div>
                   <div style="position: absolute; top: 42px; left: 50%; transform: translateX(-50%); background: ${isActiveCrew ? 'rgba(74, 222, 128, 0.9)' : 'rgba(0,0,0,0.8)'}; color: #fff; padding: 2px 6px; border-radius: 4px; font-size: 11px; font-weight: bold; white-space: nowrap; border: 1px solid ${isActiveCrew ? '#4ade80' : 'rgba(255,255,255,0.3)'};">
                     ${crew.name} 
                   </div>
                 </div>`,
          iconSize: [80, 60],
          iconAnchor: [40, 20],
          className: 'crew-marker-main'
        });
        
        const marker = L.marker([lat, lng], { icon: crewIcon })
          .addTo(mainMapRef.current)
          .bindPopup(`<strong>${crew.name}</strong><br/>
                     ${crew.foremanName}<br/>
                     ${crew.vehicle?.equipmentName || 'No vehicle'}<br/>
                     ${crew.currentWorkorder ? `Current: ${crew.currentWorkorder.jobSite?.name}` : 'No current job'}`);
        
        mainMarkersRef.current.push(marker);
        allMarkerPositions.push([lat, lng]);
      }
    });

    // Add all today's job sites
    if (allWorkorders.length > 0) {
      // Get the current active workorder
      const currentActiveCrew = activeCrewsList[currentActiveCrewIndex];
      const activeWorkorder = currentActiveCrew?.todaySchedule?.[workorderIndex];
      const activeWorkorderId = activeWorkorder?.workorderId || activeWorkorder?._id;
      
      allWorkorders.forEach(wo => {
        const coords = wo?.jobSite?.location?.coordinates || wo?.location?.coordinates;
        if (coords?.length === 2) {
          // Check if this is the active workorder by comparing IDs or by location
          const isActiveWorkorder = (wo._id && activeWorkorderId && wo._id.toString() === activeWorkorderId.toString()) ||
                                   (activeWorkorder?.jobSite?.location?.coordinates && 
                                    coords[0] === activeWorkorder.jobSite.location.coordinates[0] && 
                                    coords[1] === activeWorkorder.jobSite.location.coordinates[1]);
          
          if (isActiveWorkorder) {
            // Special marker for active workorder - icon throbs
            const activeIcon = L.divIcon({
              html: `<div style="position: relative; width: 24px; height: 24px;">
                       <div style="background: #4ade80; width: 24px; height: 24px; border-radius: 50%; border: 3px solid #fff; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(0,0,0,0.6); animation: throb 2s infinite;">
                         <svg viewBox="0 0 24 24" style="width: 16px; height: 16px; fill: #fff;">
                           <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
                         </svg>
                       </div>
                     </div>`,
              iconSize: [24, 24],
              iconAnchor: [12, 12],
              className: 'active-job-marker'
            });
            
            L.marker([coords[1], coords[0]], { icon: activeIcon })
              .addTo(mainMapRef.current)
              .bindPopup(`<strong>ACTIVE: ${wo.jobSite?.name || wo.jobName}</strong><br/>
                         ${wo.clientName}<br/>
                         WO #${wo.number}<br/>
                         ${wo.crewName || 'Unassigned'}`);
          } else {
            // Regular job markers
            const color = wo.workComplete ? '#10b981' : '#f59e0b';
            
            const jobMarker = L.circleMarker([coords[1], coords[0]], {
              color: color,
              fillColor: color,
              fillOpacity: wo.workComplete ? 0.3 : 0.5,
              radius: 6,
              weight: 1
            })
              .addTo(mainMapRef.current)
              .bindPopup(`<strong>${wo.jobSite?.name || wo.jobName}</strong><br/>
                         ${wo.clientName}<br/>
                         WO #${wo.number}<br/>
                         ${wo.crewName || 'Unassigned'}`);
            
            mainMarkersRef.current.push(jobMarker);
          }
          
          // Add position to array for bounds calculation
          allMarkerPositions.push([coords[1], coords[0]]);
        }
      });
    }
    
    // Fit map to show markers, with special handling for outliers
    setTimeout(() => {
      if (mainMapRef.current && allMarkerPositions.length > 0) {
        // Calculate the center point of all markers
        const centerLat = allMarkerPositions.reduce((sum, pos) => sum + pos[0], 0) / allMarkerPositions.length;
        const centerLng = allMarkerPositions.reduce((sum, pos) => sum + pos[1], 0) / allMarkerPositions.length;
        
        // Calculate distances from center for each marker
        const distances = allMarkerPositions.map(pos => {
          const latDiff = pos[0] - centerLat;
          const lngDiff = pos[1] - centerLng;
          return Math.sqrt(latDiff * latDiff + lngDiff * lngDiff);
        });
        
        // Find median distance
        const sortedDistances = [...distances].sort((a, b) => a - b);
        const medianDistance = sortedDistances[Math.floor(sortedDistances.length / 2)];
        
        // Filter out outliers (markers that are more than 3x the median distance)
        const filteredPositions = allMarkerPositions.filter((pos, index) => {
          return distances[index] <= medianDistance * 3;
        });
        
        // If we have an active workorder that's an outlier, we'll handle it separately
        const activeWorkorder = activeCrewsList[currentActiveCrewIndex]?.todaySchedule?.[workorderIndex];
        let activeWorkorderPosition = null;
        
        if (activeWorkorder) {
          const coords = activeWorkorder?.jobSite?.location?.coordinates || activeWorkorder?.location?.coordinates;
          if (coords?.length === 2) {
            activeWorkorderPosition = [coords[1], coords[0]];
          }
        }
        
        // Use filtered positions if we have them, otherwise use all
        const positionsToFit = filteredPositions.length > 0 ? filteredPositions : allMarkerPositions;
        
        if (positionsToFit.length > 0) {
          const bounds = L.latLngBounds(positionsToFit);
          mainMapRef.current.fitBounds(bounds, { 
            padding: [40, 40],
            maxZoom: 14 // Don't zoom in too close
          });
        } else {
          // Fallback to HMI yard
          mainMapRef.current.setView(hmiYardCoords, 12);
        }
        
        mainMapRef.current.invalidateSize();
      } else if (mainMapRef.current) {
        // Fallback to HMI yard if no markers
        mainMapRef.current.invalidateSize();
        mainMapRef.current.setView(hmiYardCoords, 12);
      }
    }, 200);
      } catch (error) {
        console.error('[TV Dashboard] Error creating map:', error);
      }
    }, 100);
  }, [crews, allWorkorders, hmiYardCoords, index, workorderIndex]);

  // Cleanup maps on component unmount
  useEffect(() => {
    return () => {
      // Clean up all maps on unmount
      if (mainMapRef.current) {
        try {
          mainMapRef.current.off();
          mainMapRef.current.remove();
        } catch (error) {
          console.warn('[TV Dashboard] Error cleaning up main map:', error);
        }
        mainMapRef.current = null;
      }
      if (mapRef.current) {
        try {
          mapRef.current.off();
          mapRef.current.remove();
        } catch (error) {
          console.warn('[TV Dashboard] Error cleaning up detail map:', error);
        }
        mapRef.current = null;
      }
      if (miniMapRef.current) {
        try {
          miniMapRef.current.off();
          miniMapRef.current.remove();
        } catch (error) {
          console.warn('[TV Dashboard] Error cleaning up mini map:', error);
        }
        miniMapRef.current = null;
      }
      if (propertyMapRef.current) {
        try {
          propertyMapRef.current.off();
          propertyMapRef.current.remove();
        } catch (error) {
          console.warn('[TV Dashboard] Error cleaning up property map:', error);
        }
        propertyMapRef.current = null;
      }
    };
  }, []);

  // Render detail map for current crew
  useEffect(() => {
    const activeCrewsList = filterActiveCrews(crews);
    const crew = activeCrewsList[index];
    if (!crew || !mapContainerRef.current) return;
  
    // Clear old map with error handling
    if (mapRef.current) {
      try {
        mapRef.current.off(); // Remove all event listeners
        mapRef.current.remove();
      } catch (error) {
        console.warn('[TV Dashboard] Error removing detail map:', error);
      }
      markersRef.current = [];
      mapRef.current = null;
    }
  
    // Determine best location source
    let centerLat, centerLng, locationSource;
    
    if (crew.vehicle?.latitude && crew.vehicle?.longitude) {
      centerLat = crew.vehicle.latitude;
      centerLng = crew.vehicle.longitude;
      locationSource = 'Vehicle GPS';
    } else if (crew.mobileLocation?.latitude && crew.mobileLocation?.longitude) {
      centerLat = crew.mobileLocation.latitude;
      centerLng = crew.mobileLocation.longitude;
      locationSource = 'Mobile App';
    } else if (crew.bestLocation?.latitude && crew.bestLocation?.longitude) {
      centerLat = crew.bestLocation.latitude;
      centerLng = crew.bestLocation.longitude;
      locationSource = crew.locationSource || 'GPS';
    }
    
    if (centerLat && centerLng) {
      mapRef.current = L.map(mapContainerRef.current, {
        zoomControl: false  // Hide zoom controls for TV display
      }).setView(
        [centerLat, centerLng],
        13
      );
      
      // Dark theme tiles
      L.tileLayer('https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; OpenStreetMap contributors &copy; CARTO',
      }).addTo(mapRef.current);
  
      // Main crew marker
      const crewIcon = L.divIcon({
        html: `<div style="background-color: #4ade80; border: 2px solid #fff; border-radius: 50%; width: 20px; height: 20px;"></div>`,
        iconSize: [20, 20],
        className: 'crew-marker'
      });
      
      const marker = L.marker([centerLat, centerLng], { icon: crewIcon })
        .addTo(mapRef.current)
        .bindPopup(`<strong>${crew.name}</strong><br/>${locationSource}<br/>Speed: ${crew.vehicle?.speed || 0} mph`)
        .openPopup();
  
      markersRef.current = [marker];
      
      // Add GPS history trail if available
      if (crew.gpsHistory && crew.gpsHistory.length > 1) {
        const trail = crew.gpsHistory
          .filter(point => point.latitude && point.longitude)
          .map(point => [point.latitude, point.longitude]);
        
        if (trail.length > 1) {
          L.polyline(trail, {
            color: '#4ade80',
            weight: 3,
            opacity: 0.5
          }).addTo(mapRef.current);
        }
      }
  
      // Add workorder markers
      (crew.todaySchedule || []).forEach((job) => {
        const coords = job?.jobSite?.location?.coordinates || job?.location?.coordinates;
        if (coords?.length === 2) {
          const jobColor = job.status === 'completed' ? '#4ade80' : 
                          job.status === 'in-progress' ? '#3b82f6' : '#fbbf24';
          
          const jobMarker = L.circleMarker([coords[1], coords[0]], {
            color: jobColor,
            fillColor: jobColor,
            fillOpacity: 0.7,
            radius: 8,
            weight: 2
          })
            .addTo(mapRef.current)
            .bindPopup(`<strong>${job.jobSite?.name || 'Job Site'}</strong><br/>
                       ${job.clientName}<br/>
                       Status: ${job.status}<br/>
                       ${job.estimatedStartTime ? `Time: ${new Date(job.estimatedStartTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}` : ''}`);
          markersRef.current.push(jobMarker);
        }
      });
    }
  }, [crews, index]);

  // Render mini map for current crew
  useEffect(() => {
    const activeCrewsList = filterActiveCrews(crews);
    const crew = activeCrewsList[index];
    if (!crew || !miniMapContainerRef.current) return;

    // Determine best location source
    let centerLat, centerLng;
    
    if (crew.vehicle?.latitude && crew.vehicle?.longitude) {
      centerLat = crew.vehicle.latitude;
      centerLng = crew.vehicle.longitude;
    } else if (crew.mobileLocation?.latitude && crew.mobileLocation?.longitude) {
      centerLat = crew.mobileLocation.latitude;
      centerLng = crew.mobileLocation.longitude;
    } else if (crew.bestLocation?.latitude && crew.bestLocation?.longitude) {
      centerLat = crew.bestLocation.latitude;
      centerLng = crew.bestLocation.longitude;
    }
    
    if (!centerLat || !centerLng) return;

    // Clear old map with error handling
    if (miniMapRef.current) {
      try {
        miniMapRef.current.off(); // Remove all event listeners
        miniMapRef.current.remove();
      } catch (error) {
        console.warn('[TV Dashboard] Error removing mini map:', error);
      }
      miniMapRef.current = null;
    }

    // Create mini map
    miniMapRef.current = L.map(miniMapContainerRef.current, {
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      touchZoom: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      boxZoom: false,
      keyboard: false
    }).setView([centerLat, centerLng], 17); // More zoomed in
    
    // Satellite imagery base layer
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      attribution: '',
      maxZoom: 19,
      className: 'mini-map-tiles'
    }).addTo(miniMapRef.current);
    
    // Add street labels overlay
    L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}{r}.png', {
      attribution: '',
      maxZoom: 19,
      opacity: 0.8
    }).addTo(miniMapRef.current);

    // Add CSS to darken mini map tiles and animations
    const style = document.createElement('style');
    style.innerHTML = `
      .mini-map-tiles { filter: brightness(0.7); }
      @keyframes pulse {
        0% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.7; transform: scale(1.1); }
        100% { opacity: 1; transform: scale(1); }
      }
      @keyframes throb {
        0% { transform: scale(1); }
        50% { transform: scale(1.15); }
        100% { transform: scale(1); }
      }
      @keyframes ticker {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
    `;
    document.head.appendChild(style);

    // Add crew marker - truck icon
    const crewIcon = L.divIcon({
      html: `<div style="display: flex; align-items: center; justify-content: center;">
               <div style="background-color: #3b82f6; padding: 4px; border-radius: 4px; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px rgba(0,0,0,0.4);">
                 <svg viewBox="0 0 24 24" style="width: 20px; height: 20px; fill: #fff;">
                   <path d="M18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5M19.5,9.5L21.46,12H17V9.5M6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5M20,8H17V4H3C1.89,4 1,4.89 1,6V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V12L20,8Z"/>
                 </svg>
               </div>
             </div>`,
      iconSize: [28, 28],
      iconAnchor: [14, 14],
      className: 'crew-truck-mini'
    });
    
    L.marker([centerLat, centerLng], { icon: crewIcon }).addTo(miniMapRef.current);

    // Add job markers if they're within view
    if (crew.todaySchedule && crew.todaySchedule.length > 0) {
      crew.todaySchedule.forEach(job => {
        const coords = job?.jobSite?.location?.coordinates || job?.location?.coordinates;
        if (coords?.length === 2) {
          const jobLat = coords[1];
          const jobLng = coords[0];
          
          // Calculate distance from crew to job
          const distance = L.latLng(centerLat, centerLng).distanceTo(L.latLng(jobLat, jobLng));
          
          // Only show jobs within 2km
          if (distance < 2000) {
            const jobColor = job.workComplete ? '#10b981' : 
                           job.startTime ? '#3b82f6' : '#f59e0b';
            
            L.circleMarker([jobLat, jobLng], {
              color: jobColor,
              fillColor: jobColor,
              fillOpacity: 0.7,
              radius: 6,
              weight: 2
            }).addTo(miniMapRef.current);
          }
        }
      });
    }

    // Force invalidate size after a short delay
    setTimeout(() => {
      if (miniMapRef.current) {
        miniMapRef.current.invalidateSize();
      }
    }, 100);
  }, [crews, index]);
  

  const getStatusColor = (status) => {
    switch(status) {
      case 'completed': return '#4ade80';
      case 'in-progress': return '#3b82f6';
      case 'scheduled': return '#fbbf24';
      default: return '#9ca3af';
    }
  };

  // console.log('[TV Dashboard] Active crew:', crew?.name)

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    const days = Math.floor((new Date() - date) / (1000 * 60 * 60 * 24));
    return `${date.toLocaleDateString()} (${days} days ago)`;
  };

  // Calculate job statistics
  const calculateJobStats = () => {
    let totalJobs = 0;
    let completedJobs = 0;
    
    crews.forEach(crew => {
      if (crew.todaySchedule && crew.todaySchedule.length > 0) {
        totalJobs += crew.todaySchedule.length;
        completedJobs += crew.todaySchedule.filter(wo => wo.workComplete).length;
      }
    });
    
    return { totalJobs, completedJobs };
  };
  
  const jobStats = calculateJobStats();
  // console.log('CREW::', crew)
  
  // Check if we need Yodeck wrapper or have specific dimensions in URL
  const urlParams = new URLSearchParams(window.location.search);
  const widthParam = urlParams.get('width');
  const heightParam = urlParams.get('height');
  const modeParam = urlParams.get('mode');
  
  const isYodeck = typeof window !== 'undefined' && (
    navigator.userAgent.includes('Yodeck') || 
    window.location.search.includes('yodeck') ||
    modeParam === 'tv' ||
    window.innerWidth === window.screen.width
  );
  
  const content = (
    <Box className={classes.container}>
      {/* Main Content - No header, more room */}
      <Box className={classes.mainContent} style={{ height: '100%' }}>
        {/* Left Panel - Fleet Summary and Main Map */}
        <Box className={classes.leftPanel}>
          {/* Fleet Summary at Top */}
          <Box className={classes.summarySection}>
            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                Fleet Summary
              </Typography>
              <Typography variant="caption" style={{ color: '#94a3b8', fontSize: '0.75rem' }}>
                {lastUpdated ? `Updated: ${lastUpdated.toLocaleTimeString()}` : 'Loading...'}
              </Typography>
            </Box>
            {stats && (
              <Box style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 16 }}>
                <Box className={classes.statItem}>
                  <AssignmentTurnedInIcon style={{ fontSize: 20, color: '#4ade80', marginBottom: 4 }} />
                  <span className="label">Jobs Complete</span>
                  <span className="value">{jobStats.completedJobs}/{jobStats.totalJobs}</span>
                </Box>
                <Box className={classes.statItem}>
                  <CheckCircleIcon style={{ fontSize: 20, color: '#4ade80', marginBottom: 4 }} />
                  <span className="label">Sites Reviewed</span>
                  <span className="value">{stats.reviewedCountySites}/{stats.totalCountySites}</span>
                </Box>
                <Box className={classes.statItem}>
                  <LocalShippingIcon style={{ fontSize: 20, color: '#3b82f6', marginBottom: 4 }} />
                  <span className="label">Active Crews</span>
                  <span className="value">{activeCrews.length}</span>
                </Box>
                <Box className={classes.statItem}>
                  <ReportProblemIcon style={{ fontSize: 20, color: '#f59e0b', marginBottom: 4 }} />
                  <span className="label">Issues Reported</span>
                  <span className="value">0</span>
                </Box>
                <Box className={classes.statItem}>
                  <BuildIcon style={{ fontSize: 20, color: '#10b981', marginBottom: 4 }} />
                  <span className="label">Issues Resolved</span>
                  <span className="value">0</span>
                </Box>
                <Box className={classes.statItem}>
                  <NatureIcon style={{ fontSize: 20, color: '#ef4444', marginBottom: 4 }} />
                  <span className="label">Dead Plants</span>
                  <span className="value">0</span>
                </Box>
              </Box>
            )}
          </Box>

          {/* Main Map */}
          <Box className={classes.mainMap} style={{ flex: 1, position: 'relative' }}>
            <div ref={mainMapContainerRef} style={{ 
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: '100%', 
              height: '100%' 
            }} />
            
            {/* Map Legend */}
            <Box className={classes.mapLegend}>
              <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                Map Legend
              </Typography>
              <div className={classes.legendItem}>
                <div className={classes.legendDot} style={{ backgroundColor: '#3b82f6' }} />
                <span>Crew Working</span>
              </div>
              <div className={classes.legendItem}>
                <div className={classes.legendDot} style={{ backgroundColor: '#fbbf24' }} />
                <span>Crew Idle</span>
              </div>
              <div className={classes.legendItem}>
                <div className={classes.legendDot} style={{ backgroundColor: '#10b981', opacity: 0.5 }} />
                <span>Completed Job</span>
              </div>
              <div className={classes.legendItem}>
                <div className={classes.legendDot} style={{ backgroundColor: '#f59e0b', opacity: 0.7 }} />
                <span>Scheduled Job</span>
              </div>
            </Box>
          </Box>
        </Box>

        {/* Right Sidebar - Crew Details Only */}
        <Box className={classes.rightSidebar}>
          <Box className={classes.crewDetailBox}>
            {crew ? (
              <Box style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {/* Compact Header */}
                <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                    <Typography variant="h5" style={{ fontWeight: 'bold', color: '#fff', lineHeight: 1, overflow: 'hidden' }}>
                        {crew.name} {crew?.foremanName ? `(${crew.foremanName})` : ''}
                      </Typography>
                      <div style={{ fontSize: 12, textAlign: 'right' }}>
                          <span style={{ color: '#94a3b8' }}>Crew {index + 1}/{activeCrews.length}</span>
                          {secondsUntilNext === -1 ? (
                            <span style={{ color: '#f59e0b', marginLeft: 8 }}>• Viewing photos...</span>
                          ) : (
                            <span style={{ color: '#4ade80', marginLeft: 8 }}>• Next: {secondsUntilNext}s</span>
                          )}
                      </div>
                      
                </Box>

                {/* Employees Section */}
                <Box style={{ flexShrink: 0, marginBottom: 12 }}>
                  {/* <Typography variant="caption" style={{ color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, fontSize: '0.7rem' }}>
                    Crew Members ({crew.employees?.filter(e => e.isClockedIn).length || 0}/{crew.employees?.length || 0} clocked in)
                  </Typography> */}
                  <Box style={{ display: 'flex', marginTop: 8, overflow: 'hidden' }}>
                    {crew.employees?.map((emp, idx) => {
                      // Calculate avatar size based on number of employees to fit in one row
                      // Assuming ~500px width, minus gaps, divided by number of employees
                      const employeeCount = crew.employees.length;
                      const maxWidth = 300; // Approximate available width
                      const gaps = (employeeCount - 1) * 8; // 8px gap between items
                      const itemWidth = Math.min(120, Math.floor((maxWidth - gaps) / employeeCount));
                      // Fixed avatar size
                      const avatarSize = Math.min(80, itemWidth - 8); // Fixed at 80px max
                      
                      return (
                        <Box key={idx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: `0 0 ${itemWidth}px`, marginRight: idx < employeeCount - 1 ? 8 : 0 }}>
                          <Avatar
                            src={emp.profile_photo_url}
                            style={{
                              width: avatarSize,
                              height: avatarSize,
                              border: `4px solid ${emp.isAbsent ? '#0000FF' : emp.isClockedIn ? '#4ade80' : emp.isCheckedIn ? '#fbbf24' : '#6b7280'}`,
                              opacity: emp.isClockedIn ? 1 : 0.7,
                              marginBottom: 4
                            }}
                          >
                            {!emp.profile_photo_url && (emp.firstName?.charAt(0) || 'E')}
                          </Avatar>
                          <Typography variant="caption" style={{ 
                            fontSize: '0.65rem', 
                            textAlign: 'center',
                            color: emp.isAbsent ? '#0000FF' : emp.isClockedIn ? '#4ade80' : emp.isCheckedIn ? '#fbbf24' : '#6b7280'
                          }}>
                            {emp.firstName}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
                
                {/* Mini Map and Vehicle Details Side by Side */}
                <Box style={{ 
                  display: 'flex', 
                  marginBottom: 12,
                  flexShrink: 0,
                  height: 130
                }}>
                  {/* Mini Map - Half Width */}
                  {(crew.vehicle?.latitude || crew.mobileLocation?.latitude || crew.bestLocation?.latitude) && (
                    <Box className={classes.miniMap} style={{ height: 130, flex: '0 0 48%', marginRight: 16 }}>
                      <div ref={miniMapContainerRef} style={{ width: '100%', height: '100%' }} />
                    </Box>
                  )}
                  
                  {/* Vehicle and Job Details */}
                  <Box style={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto' }}>
                    <Box style={{ marginBottom: 8 }}>
                      <Typography variant="caption" style={{ color: '#6b7280', fontSize: '0.65rem' }}>VEHICLE</Typography>
                      <Typography variant="body2" style={{ color: '#fff' }}>
                        {crew.vehicle?.equipmentName || 'No vehicle'}
                      </Typography>
                      {crew.vehicle && (
                        <Typography variant="caption" style={{ color: crew.vehicle.isDriving ? '#4ade80' : '#fbbf24' }}>
                          {crew.vehicle.isDriving ? 'Driving' : 'Idle'} • {crew.vehicle.speed}mph
                        </Typography>
                      )}
                    </Box>
                    
                    <Box>
                      <Typography variant="caption" style={{ color: '#6b7280', fontSize: '0.65rem' }}>TODAY'S PROGRESS</Typography>
                      <Typography variant="h5" style={{ color: '#fff', fontWeight: 'bold' }}>
                        {workorderIndex + 1} / {crew.todaySchedule?.length || 0}
                      </Typography>
                      <Typography variant="caption" style={{ color: '#94a3b8' }}>
                        Jobs Complete
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Site Review Averages - Compact Display */}
                {crew.averageReviews && crew.averageReviews.length > 0 && (
                  <Box style={{ 
                    marginBottom: 12,
                    flexShrink: 0,
                    background: 'rgba(255,255,255,0.03)',
                    borderRadius: 8,
                    padding: '8px 12px',
                    border: '1px solid rgba(255,255,255,0.1)'
                  }}>
                    <Typography variant="caption" style={{ color: '#6b7280', fontSize: '0.65rem', marginBottom: 4, display: 'block' }}>
                      SITE REVIEW AVERAGES
                    </Typography>
                    <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                      {crew.averageReviews.map((review, idx) => {
                        const rating = review.avgRating || 0;
                        const ratingColor = rating >= 4 ? '#4ade80' : rating >= 3 ? '#fbbf24' : rating >= 2 ? '#f59e0b' : '#ef4444';
                        const displayName = review.name.charAt(0).toUpperCase() + review.name.slice(1);
                        
                        return (
                          <Box key={idx} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <Typography variant="caption" style={{ fontSize: '0.7rem', color: '#94a3b8' }}>
                              {displayName}:
                            </Typography>
                            <Typography variant="caption" style={{ 
                              fontSize: '0.85rem',
                              fontWeight: 'bold',
                              color: ratingColor
                            }}>
                              {rating.toFixed(1)}
                            </Typography>
                            <Typography variant="caption" style={{ fontSize: '0.6rem', color: '#6b7280' }}>
                              ({review.count})
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                )}

                {/* Current Workorder Section - Fills remaining space */}
                {crew.todaySchedule && crew.todaySchedule.length > 0 && crew.todaySchedule[workorderIndex] && (() => {
                  const wo = crew.todaySchedule[workorderIndex];
                  const timeDisplay = (() => {
                    if (wo.workComplete && wo.completedAt) {
                      return `Completed: ${formatTimeAgo(wo.completedAt)}`;
                    } else if (wo.startTime) {
                      return `Started: ${formatTime(wo.startTime)}`;
                    } else {
                      return `Scheduled: ${formatTime(wo.estimatedStartTime)}`;
                    }
                  })();
                  
                  return (
                    <Box style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', minHeight: 200, overflow: 'auto' }}>
                      <Box style={{ 
                        background: 'rgba(255,255,255,0.05)', 
                        borderRadius: 8, 
                        padding: 16,
                        border: '1px solid rgba(255,255,255,0.1)',
                        marginBottom: 16
                      }}>
                        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                          {/* <Typography variant="caption" style={{ color: '#94a3b8' }}>
                            Current Job ({workorderIndex + 1} of {crew.todaySchedule.length})
                          </Typography> */}
                           <Box style={{ flex: 1 }}>
                            <Typography variant="body1" style={{ fontWeight: 'bold', marginBottom: 4 }}>
                              {wo.jobSite?.name || 'Unknown Site'}
                            </Typography>
                            <Typography variant="body2" style={{ marginBottom: 2 }}>
                              {wo.clientName} • WO #{wo.number}
                            </Typography>
                            <Typography variant="caption" style={{ color: '#94a3b8', display: 'block' }}>
                              {wo.jobSite?.address || 'No address'}
                            </Typography>
                            <Typography variant="caption" style={{ color: '#4ade80', marginTop: 8, display: 'block' }}>
                              {timeDisplay}
                            </Typography>
                          </Box>
                        
                               <Box style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: '0.7rem', color: '#6b7280', minWidth: 120, textAlign: 'right' }}>
                               <Chip 
                            label={wo.status.toUpperCase()}
                            size="small"
                            style={{ 
                              backgroundColor: getStatusColor(wo.status),
                              height: 20,
                              fontWeight: 'bold'
                            }}
                          />
                            {workorderDetails?.lastIrrigationCheck && (
                              <Box>
                                <Typography variant="caption" style={{ fontSize: '0.65rem', color: '#6b7280', display: 'block' }}>Irrigation</Typography>
                                <Typography variant="caption" style={{ fontSize: '0.7rem', color: '#94a3b8' }}>{formatTimeAgo(workorderDetails.lastIrrigationCheck)}</Typography>
                              </Box>
                            )}
                            {workorderDetails?.lastHerbicideApplication && (
                              <Box>
                                <Typography variant="caption" style={{ fontSize: '0.65rem', color: '#6b7280', display: 'block' }}>Herbicide</Typography>
                                <Typography variant="caption" style={{ fontSize: '0.7rem', color: '#94a3b8' }}>{formatTimeAgo(workorderDetails.lastHerbicideApplication)}</Typography>
                              </Box>
                            )}
                          </Box>
                        </Box>
                        <Box style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                          {/* <Box style={{ flex: 1 }}>
                            <Typography variant="body1" style={{ fontWeight: 'bold', marginBottom: 4 }}>
                              {wo.jobSite?.name || 'Unknown Site'}
                            </Typography>
                            <Typography variant="body2" style={{ marginBottom: 2 }}>
                              {wo.clientName} • WO #{wo.number}
                            </Typography>
                            <Typography variant="caption" style={{ color: '#94a3b8', display: 'block' }}>
                              {wo.jobSite?.address || 'No address'}
                            </Typography>
                            <Typography variant="caption" style={{ color: '#4ade80', marginTop: 8, display: 'block' }}>
                              {timeDisplay}
                            </Typography>
                          </Box> */}
                          
                          {/* Irrigation and Herbicide info - lower right */}
                     
                        </Box>
                        
                        {/* Jobsite Map and Site Info Row */}
                        {(wo?.jobSite?.location?.coordinates || wo?.location?.coordinates || workorderDetails?.propertyLineData?.data?.[0]?.googleMapsFormat || 
                          (workorderDetails && (workorderDetails.siteReviews?.length > 0 || workorderDetails.allIssues?.length > 0))) && (
                          <Box style={{ marginTop: 12, display: 'flex', alignItems: 'stretch' }}>
                            {/* Site Information - Left Half */}
                            {workorderDetails && (workorderDetails.siteReviews?.length > 0 || workorderDetails.allIssues?.length > 0) ? (
                              <Box style={{ 
                                background: 'rgba(255,255,255,0.03)', 
                                borderRadius: 8, 
                                padding: 12,
                                border: '1px solid rgba(255,255,255,0.1)',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                flex: '0 0 48%',
                                marginRight: 16
                              }}>
                                {/* Site Reviews */}
                                {workorderDetails.siteReviews?.length > 0 && (
                                  <Box style={{ marginBottom: workorderDetails.allIssues?.length > 0 ? 8 : 0 }}>
                                    <Typography variant="caption" style={{ color: '#94a3b8', marginBottom: 4, display: 'block', fontSize: '0.65rem' }}>
                                      Last Review: {formatTimeAgo(workorderDetails.siteReviews[workorderDetails.siteReviews.length - 1].created_at)}
                                    </Typography>
                                    <Box style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                      {workorderDetails.siteReviews[workorderDetails.siteReviews.length - 1].reviewData?.map((item, idx) => (
                                        <Box key={idx} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                          <Typography variant="caption" style={{ fontSize: '0.65rem', color: '#6b7280' }}>
                                            {item.name}:
                                          </Typography>
                                          <Typography variant="caption" style={{ 
                                            fontSize: '0.75rem',
                                            fontWeight: 'bold',
                                            color: item.rating >= 4 ? '#4ade80' : item.rating >= 3 ? '#fbbf24' : '#ef4444'
                                          }}>
                                            {item.rating}
                                          </Typography>
                                        </Box>
                                      ))}
                                    </Box>
                                  </Box>
                                )}
                                
                                {/* Open Issues */}
                                {workorderDetails.allIssues?.length > 0 && (
                                  <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Box style={{ textAlign: 'center' }}>
                                      <Typography variant="h5" style={{ color: '#f59e0b', fontWeight: 'bold', lineHeight: 1 }}>
                                        {workorderDetails.allIssues.length}
                                      </Typography>
                                      <Typography variant="caption" style={{ color: '#f59e0b', fontSize: '0.65rem' }}>
                                        Open Issue{workorderDetails.allIssues.length > 1 ? 's' : ''}
                                      </Typography>
                                    </Box>
                                  </Box>
                                )}
                              </Box>
                            ) : (
                              <Box style={{ flex: '0 0 48%', marginRight: 16 }} /> // Empty placeholder
                            )}
                            
                            {/* Jobsite Map - Right Half */}
                            {(workorderDetails?.propertyLineData?.data?.[0]?.googleMapsFormat || wo?.jobSite?.location?.coordinates || wo?.location?.coordinates) ? (
                              <Box style={{ 
                                height: '100%', 
                                minHeight: 200,
                                borderRadius: 8, 
                                overflow: 'hidden', 
                                border: '1px solid rgba(255,255,255,0.1)',
                                flex: '1 1 auto'
                              }}>
                                <div ref={propertyMapContainerRef} style={{ width: '100%', height: '100%' }} />
                              </Box>
                            ) : (
                              <Box style={{ flex: '1 1 auto' }} /> // Empty placeholder
                            )}
                          </Box>
                        )}
                        
                        {/* Photo Ticker - Scrolling Style */}
                        {workorderDetails?.uploads?.length > 0 && (
                          <Box className={classes.photoTicker} style={{
                            height: crew.pastDueWorkorders?.length > 0 ? 165 : 'auto',
                            maxHeight: crew.pastDueWorkorders?.length > 0 ? 165 : 350,
                            flex: '0 1 auto'
                          }}>
                            <Typography variant="caption" style={{ 
                              position: 'absolute', 
                              top: 4, 
                              left: 8, 
                              color: '#94a3b8', 
                              zIndex: 2,
                              background: 'rgba(0,0,0,0.7)',
                              padding: '2px 8px',
                              borderRadius: 4
                            }}>
                              {workorderDetails.uploads.length} Photos
                            </Typography>
                            <Box 
                              className={classes.photoTickerInner}
                              style={{ 
                                animation: `ticker ${photoTickerSpeed}s linear infinite`,
                                width: workorderDetails.uploads.length > 2 ? `${(workorderDetails.uploads.length * 2 * 248)}px` : 'auto'
                              }}
                            >
                              {/* Duplicate the photos array for seamless loop */}
                              {[...workorderDetails.uploads, ...workorderDetails.uploads].map((photo, idx) => {
                                // Format the timestamp
                                const formatPhotoTime = (dateStr) => {
                                  if (!dateStr) return null
                                  const date = new Date(dateStr);
                                  return date.toLocaleString('en-US', { 
                                    month: 'short', 
                                    day: 'numeric',
                                    hour: '2-digit', 
                                    minute: '2-digit'
                                  });
                                };
                                
                                return (
                                  <Box key={`${photo._id}-${idx}`} className={classes.photoTickerItem} style={{
                                    height: crew.pastDueWorkorders?.length > 0 ? 150 : 320
                                  }}>
                                    <Chip
                                      label={photo.mobileUploadType || `Photo ${(idx % workorderDetails.uploads.length) + 1}`}
                                      size="small"
                                      style={{ 
                                        position: 'absolute',
                                        top: 4,
                                        left: 4,
                                        height: 18,
                                        fontSize: '0.6rem',
                                        backgroundColor: photo.mobileUploadType === 'before' ? '#3b82f6' : 
                                                        photo.mobileUploadType === 'after' ? '#4ade80' : '#6b7280',
                                        color: '#fff',
                                        zIndex: 1
                                      }}
                                    />
                                    {/* Timestamp label */}
                                    <Typography 
                                      variant="caption" 
                                      style={{ 
                                        position: 'absolute',
                                        bottom: 4,
                                        left: 4,
                                        color: '#fff',
                                        fontSize: '0.65rem',
                                        background: 'rgba(0,0,0,0.7)',
                                        padding: '2px 6px',
                                        borderRadius: 4,
                                        zIndex: 1
                                      }}
                                    >
                                      {formatPhotoTime(photo.created_at || photo.timestamp)}
                                    </Typography>
                                    <img 
                                      src={photo.url} 
                                      alt={`${photo.mobileUploadType || 'Site'} photo`}
                                      style={{ 
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                      }}
                                    />
                                  </Box>
                                );
                              })}
                            </Box>
                          </Box>
                        )}
                      </Box>

                    </Box>
                  );
                })()}

                {/* Crew's Past Due - Compact Table */}
                {crew.pastDueWorkorders && crew.pastDueWorkorders.length > 0 && (
                  <Box className={classes.pastDueSection}>
                    <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: 4, color: '#ef4444' }}>
                      Past Due ({crew.pastDueWorkorders.length})
                    </Typography>
                    <table className={classes.pastDueTable} style={{ width: '100%' }}>
                      <thead>
                        <tr>
                          <th>WO#</th>
                          <th>Job</th>
                          <th>Client</th>
                          <th>Due</th>
                        </tr>
                      </thead>
                      <tbody>
                        {crew.pastDueWorkorders.slice(0, 3).map((wo, idx) => (
                          <tr key={wo._id || idx}>
                            <td>{wo.number}</td>
                            <td title={wo.jobName}>{wo.jobName || 'N/A'}</td>
                            <td title={wo.clientName}>{wo.clientName}</td>
                            <td>{new Date(wo.scheduledDate).toLocaleDateString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>
                )}
              </Box>
            ) : (
              <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <CircularProgress style={{ color: '#4ade80' }} size={40} />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
  
  // If Yodeck or specific dimensions requested, wrap in a fixed size container
  if (isYodeck || widthParam || heightParam) {
    return (
      <div style={{
        width: widthParam || '1920px',
        height: heightParam || '1080px',
        position: 'relative',
        margin: '0 auto',
        overflow: 'hidden',
        background: '#0a0a0a',
        boxSizing: 'border-box'
      }}>
        {content}
      </div>
    );
  }
  
  return content;
};

const mapStateToProps = (state) => {
  return {
    url: state.url,
  }
}

export default connect(mapStateToProps)(CrewDashboard)
